<template lang="pug">
.content-wrap
	#promo1.modal.fade(tabindex='-1' aria-hidden='true').custom-font
		.modal-dialog.modal-dialog-centered.modal-promo
			.modal-content
				template(v-if="promoSelected.length > 0")
					template(v-if="getLanguage==='en'")
						.modal-header
							h4.ptitle(v-html="promoSelected[0].en_title")
							button.btn-close(type='button' data-bs-dismiss='modal' aria-label='Close')
								img(src="/new/img/close.svg")
						img(:src='imgUrl+promoSelected[0].en_image_url')
						.modal-body.mobile-display
							div.promo-content.py-3(v-html="promoSelected[0].en_body")
					template(v-else)
						.modal-header
							h5.modal-title(v-html="promoSelected[0].fil_title")
							button.btn-close(type='button' data-bs-dismiss='modal' aria-label='Close')
						img(:src='imgUrl+promoSelected[0].fil_image_url')
						.modal-body.mobile-display
							div.promo-content.py-3(v-html="promoSelected[0].fil_body")
					.btns.s2.w-25.mx-auto.mb-3.pointer(v-if="promoSelected[0].id !== 138 && promoSelected[0].id !== 143 && promoSelected[0].id !== 148" @click="toDepo") {{$t('ui.deposit_now')}}
					.btns.s2.w-25.mx-auto.mb-3.pointer(v-if="promoSelected[0].id === 138" @click="toEx('https://jilibetph.win/RF12259A28')") {{$t('ui.join_us')}}
					.btns.s2.w-25.mx-auto.mb-3.pointer(v-if="promoSelected[0].id === 143" @click="toEx('https://epicwinvip.com/RF13560800')") {{$t('ui.join_us')}}
					.btns.s2.w-25.mx-auto.mb-3.pointer(v-if="promoSelected[0].id === 148" @click="toIn('/partners')") Click to Unlock Free
	.content-top
		.con
			.mb-3(v-for="(items, category) in promoList" :key="category")
				//- p.btnform.w-md-50 {{category}}
				template(v-if="checkImg(category)")
					img(:src="getImg(category)")
				template(v-else)
					p.btnform.w-md-50 {{category}}
				.promo-content.mt-3
					.promo-box(v-for="promo in items" :key="promo.id")
						template(v-if="getLanguage==='en'")
							.promo-tumbnail
								img(:src='imgUrl+promo.en_image_url')
							.promo-title(v-html="promo.en_title")
							.promo-cta(@click="viewPromo(promo.id)") {{$t('ui.details')}}
						template(v-else)
							.promo-tumbnail
								img(:src='imgUrl+promo.fil_image_url')
							.promo-title(v-html="promo.fil_title")
							.promo-cta(@click="viewPromo(promo.id)") {{$t('ui.details')}}
</template>
<script>
import config from "@/config";
import promoItem from '@/component/_promoItems.vue'
import _ from "lodash";
import { EventBus } from '@/store/event';
export default {
	components:{
		promoItem,
	},
	data() {
    return {
      feedback: {
        success: true,
        status: ""
      },
      promoList: [],
			oriList:[],
			promoSelected: [],
      loading:false,
			imgUrl: config.imageUrl,
			checker: 0,
			eventTriggered: false
    }
  },
	computed:{
		getLanguage() {
      return this.$store.getters.language || "en"
    },
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
	},
	created(){
		$('link[rel="canonical"]').attr('href', `${window.location.protocol}//${window.location.hostname}/promotions`);
		this.getSeo("promotions")
	},
	// metaInfo(){
	// 	if(this.$store.state.user.seoInfo.meta_title && this.$store.state.user.seoInfo.meta_title === "promotions"){
	// 		return{
	// 			title: this.$store.state.user.seoInfo.meta_title,
	// 			meta:[
	// 				{vmid: "og:title",name: 'og:title', content: this.$store.state.user.seoInfo.meta_title},
	// 				{vmid: "description",name: 'description', content: this.$store.state.user.seoInfo.meta_desc},
	// 				{vmid: "og:description",name: 'og:description', content: this.$store.state.user.seoInfo.meta_desc},
	// 				{vmid: "author",name: 'author', content: this.$store.state.user.seoInfo.meta_author},
	// 				{vmid: "canonical",name: 'canonical', content: this.$store.state.user.seoInfo.meta_canonical},
	// 				{vmid: "keywords",name: 'keywords', content: this.$store.state.user.seoInfo.meta_keywords},
	// 				{vmid: "language",name: 'lang', content: this.$store.state.user.seoInfo.meta_lang},
	// 				{vmid: "url",name: 'url', content: this.$store.state.user.seoInfo.meta_url},
	// 				{vmid: "og:url",name: 'og:url', content: this.$store.state.user.seoInfo.meta_url},
	// 			],
	// 			link:[
	// 				{ rel: 'image_src', href: this.imgUrl+ this.$store.state.user.seoInfo.meta_image_url},
	// 			]
	// 		}
	// 	}else{
	// 		return{
	// 			title: this.$store.state.user.homeSeo.meta_title,
	// 			meta:[
	// 				{vmid: "og:title",name: 'og:title', content: this.$store.state.user.homeSeo.meta_title},
	// 				{vmid: "description",name: 'description', content: this.$store.state.user.homeSeo.meta_desc},
	// 				{vmid: "og:description",name: 'og:description', content: this.$store.state.user.homeSeo.meta_desc},
	// 				{vmid: "author",name: 'author', content: this.$store.state.user.homeSeo.meta_author},
	// 				{vmid: "canonical",name: 'canonical', content: this.$store.state.user.homeSeo.meta_canonical},
	// 				{vmid: "keywords",name: 'keywords', content: this.$store.state.user.homeSeo.meta_keywords},
	// 				{vmid: "language",name: 'lang', content: this.$store.state.user.homeSeo.meta_lang},
	// 				{vmid: "url",name: 'url', content: this.$store.state.user.homeSeo.meta_url},
	// 				{vmid: "og:url",name: 'og:url', content: this.$store.state.user.homeSeo.meta_url},
	// 			],
	// 			link:[
	// 				{ rel: 'image_src', href: this.imgUrl+ this.$store.state.user.homeSeo.meta_image_url},
	// 			]
	// 		}
	// 	}
    
    
  // },
  mounted(){
		window.scroll(0, 0)
		EventBus.$on("custom", (data) => {
			this.eventTriggered = true
			this.getPromoBanner(data);
		});
		setTimeout(() => {
      if (!this.eventTriggered) {
        this.getPromoBanner();
      }
    }, 100);
  },
	methods:{
		checkImg(cat){
			var list = ["share & get rewards", "slots bonus (recommended)", "slots bonus (exclusive)", "weekly giveaways", "quick tips"]
			if(list.includes(cat.toLowerCase())){
				return true
			}else{
				return false
			}
		},
		getImg(cat){
			switch(cat.toLowerCase()){
				case "share & get rewards":
					return "/assets/img/promotion/SHARE-&-GET-REWARDS.png";
				case "slots bonus (recommended)":
					return "/assets/img/promotion/SLOT-BONUS-(RECOMMENDED).png"
				case "slots bonus (exclusive)":
					return "/assets/img/promotion/SLOT-BONUS-(EXCLUSIVE).png"
				case "weekly giveaways":
					return "/assets/img/promotion/WEEKLY-GIVEAWAYS.png";
				case "quick tips":
					return "/assets/img/promotion/QUICK-TIPS.png"
			}
			
		},
		getSeo(page){
      let page_name = page
      this.$store
        .dispatch("user/getSeo", {page_name})
        .then(response => {
          this.loading = false;
          this.feedback.success = response.success
          if (this.feedback.success == true) {
						if(response.data.length > 0){
							// this.$store.dispatch("user/seoInfo", response.data[0])
						}
          } else {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
            }       
          }
        })
        .catch(response => {
          this.loading = false;
          var vm = this;
          if((typeof response.status) != 'object'){
            this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
          }
        });
    },
		getPromoBanner(option){
			this.$store
        .dispatch("user/getPromoBanner")
        .then(response => {
          this.loading = false;
          this.feedback.success = response.success
          if (this.feedback.success == true) {
						this.oriList = response.data
						this.promoList = response.data.reduce((acc, item) => {
							if (!acc[item.category]) acc[item.category] = []
							acc[item.category].push(item)
							return acc
						}, {})
						if(option){
							this.viewPromo(option)
						}
          } else {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
            }       
          }
        })
        .catch(response => {
          var vm = this;
          if((typeof response.status) != 'object'){
            this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
          }
        });
		},
		viewPromo(id){
			this.promoSelected = this.oriList.filter(item => item.id === id)
			if(this.promoSelected.length > 0){
				$("#promo1").modal("show")
			}
			
		},
		toDepo(){
			if(this.isLoggedIn){
				$("#promo1").modal("hide")
				this.$router.push("/deposit").catch(error =>{})
			}else{
				$("#promo1").modal("hide")
				$("#logModal").modal("show")
			}
		},
		toEx(link){
			window.open(link, "_blank")
		},
		toIn(link){
			$("#promo1").modal("hide")
			this.$router.push(link).catch(error =>{})
		}
	}
}
</script>
<style lang="scss" scoped>
.mobile-display{
	@media(max-width: 680px){
		// padding-left: 0;
		// padding-right: 0;
	}
	
}
.modal-dialog{
	@media(max-width: 680px){
		margin-left: 5px;
		margin-right: 5px;
	}
}
// .CASINO, .ALL, .VIP, .OTHERS, .TUTORIALS, .VIP{
// 	display: none
// }
.c-depo{
	@media (max-width: 680px){
		width: 50% !important;
	}
	@media (min-width: 681px){
		width: 25% !important;
	}
}

.w-md-50{
	@media(min-width: 768px) {
		width: 60%;
	}
}
</style>